module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    inventoty_tabs\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "申請承認"
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    },
    model: {
      value: (_vm.selectedTabModel),
      callback: function($$v) {
        _vm.selectedTabModel = $$v
      },
      expression: "selectedTabModel"
    }
  }, [_c('tab', {
    attrs: {
      "header": "申請承認"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "一括取込"
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.selectedTab == 1) ? _c('div', [_c('approval-history-all', {
    on: {
      "bRLFlag": _vm.setbRLFlag,
      "selectedItemsUpd": _vm.selectedItemsUpd
    }
  })], 1) : (_vm.selectedTab == 0) ? _c('div', [_c('approval-history', {
    on: {
      "bRLFlag": _vm.setbRLFlag,
      "selectedItemsUpd": _vm.selectedItemsUpd
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "approvalBeforeLeaveModal"
    },
    on: {
      "done": _vm.approvalBeforeLeaveoConfirmedModal
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "approvalBeforeLeaveTabModal"
    },
    on: {
      "done": _vm.approvalBeforeLeaveoConfirmedTabModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b07e81d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0050_approval_history_tabs.vue
// module id = 1036
// module chunks = 0